import { Injectable } from '@angular/core';

import { endOfDay } from 'date-fns';
import { parsePhoneNumber } from 'libphonenumber-js';

import { EpochTime } from '../interfaces/IEpochTime';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  formatColorStringToColorHex(color: string): string | null {
    if (color) return '#' + color;
    return null;
  }

  formatTagsStringToTagsArray(tags: string): string[] {
    if (tags) return tags.split(',');
    return [];
  }

  addPlusToPhoneNumber(phoneNumber: string): string | null {
    if (phoneNumber) return '+' + phoneNumber.trim();
    return null;
  }

  formatEpochToDateString(epochTime: EpochTime): string | null {
    if (!epochTime) return null;
    const timeTotal = epochTime._seconds * 1000 + Math.floor(epochTime._nanoseconds / 1000000);
    return new Date(timeTotal).toDateString();
  }

  deleteTagForColor(color: string): string {
    return color.replace('#', '');
  }

  formatTagsArrayToString(tags: string[]): string {
    const tagsString = tags.join(',');
    return encodeURIComponent(tagsString);
  }

  setPhoneNumberToE164(phoneNumber: string): string {
    return parsePhoneNumber(phoneNumber).format('E.164').toString();
  }

  setDatesToTimestamp(date: Date, key: string): number {
    if (key.toUpperCase().includes('ENDDATE')) {
      return endOfDay(date).getTime();
    }
    return date.getTime();
  }

  convertTimestampToDate(timestamp: number): Date | null {
    if (!timestamp || isNaN(timestamp)) {
      return null;
    }
    return new Date(timestamp);
  }

  convertTimestampToDateString(timestamp: number): string | null {
    const date = this.convertTimestampToDate(timestamp);
    return date ? date.toDateString() : null;
  }
}
